/* ============================================================================
   EL ALMACÉN QUE USA EL MOTOR

   Envuelve IndexedDB con las dos operaciones que el motor necesita. La lectura
   espera a las escrituras que la pantalla ya pidió: sin eso, el motor puede
   leer el valor anterior y encolar un cambio que ya no existe.
   ========================================================================== */

import { guardarEnCola, leerTrasEscrituras } from "../db/persistencia.js";

export const almacenLocal = {
    leer: (clave) => leerTrasEscrituras(clave),
    guardar: (clave, valor) => guardarEnCola(clave, valor),
};
